<template>
  <div class="day-report-bd">
    <!-- 过滤 -->
    <div class="query-filter">
      <div class="select-date">
        <div>
          <h1>{{ $t('Common.com_date') }}</h1>
          <div style="margin-bottom: 16px">
            <div class="ub ub-sp">
              <custom-date-picker
                :picker-options="beforeToday"
                :clearable="false"
                v-model="selectDate"
                type="date"
                :init-value="initValue"
                value-format="YYYY-MM-DD HH:mm:ss"
                style="width: 150px"
                @init="getTableList()"
                @change="onPageChange({ page: 1 })"
              ></custom-date-picker>
              <div>
                <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="query-filter" v-show="isFilter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8" v-if="isCoJv && showSubsidiary">
              <div class="item">
                <div class="label">{{ $t('dayScore.zu_lin_fang') }}</div>
                <div class="value">
                  <custom-select
                    url="OrganSelect"
                    :model="formSearch"
                    :params="{ childOrgType: 'CS' }"
                    v-model="formSearch.orgId"
                    :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                    :placeholder="$t('Common.com_please_select')"
                    @change="onChangeCustomer"
                    filterable
                  ></custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_location') }}</div>
                <div class="value">
                  <custom-select
                    :listener="formSearch.orgId"
                    url="MyDeviceLocationTagSelect"
                    :model="formSearch"
                    v-model="formSearch.locationId"
                    :params="{ customerId: isCoJv ? (showSubsidiary ? formSearch.orgId : '') : userInfo.rootOrgId }"
                    :props="{ label: 'locationName', value: 'locationId', map: { locationName: 'locationName' } }"
                    :placeholder="$t('Common.com_please_select')"
                    :dataFilter="dataFilter"
                    @getList="getTagsList"
                    @change="onPageChange({ page: 1 })"
                  ></custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_site') }}</div>
                <div class="value">
                  <custom-select
                    :auto="false"
                    :listener="formSearch.locationId || null"
                    url="locationSiteList"
                    :model="formSearch"
                    v-model="formSearch.siteId"
                    :params="{ locationId: formSearch.locationId, isAll: false }"
                    :props="{ label: 'siteName', value: 'siteId', map: { siteName: 'siteName' } }"
                    :placeholder="$t('Common.com_please_select')"
                    @getList="getTagsList1"
                    :dataFilter="dataFilter1"
                    @change="onPageChange({ page: 1 })"
                  ></custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_belong_to_department') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId', checkStrictly: true, map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice: 1 }"
                    :placeholder="$t('Common.com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="filter-values" v-show="isFilter">
        <div class="label">{{ $t('Common.com_filter_item') }}</div>
        <div class="values">
          <el-tag
            v-if="formSearch.orgId"
            closable
            @close="
              formSearch.orgId = '';
              formSearch.orgName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.orgName }}
          </el-tag>
          <el-tag
            v-if="formSearch.locationId"
            closable
            @close="
              formSearch.locationId = '';
              formSearch.locationName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.locationName }}
          </el-tag>
          <el-tag
            v-if="formSearch.siteId"
            closable
            @close="
              formSearch.siteId = '';
              formSearch.siteName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.siteName }}
          </el-tag>
          <el-tag
            v-if="formSearch.departmentId"
            closable
            @close="
              formSearch.departmentId = '';
              formSearch.departmentName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.departmentName }}
          </el-tag>
          <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
        </div>
      </div>
    </div>
    <div style="margin-top: 24px" class="decive_box_ref">
      <location-list :selectDate="selectDate" :permission="{ set: funcView.cleanscore_daily_setTarget, check: formSearch.isToday }" :list="tableList" :siteId="formSearch.siteId" @success="getTableList"></location-list>
    </div>
    <div class="table-footer">
      <custom-pagination radius style="padding: 20px 24px" :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import locationList from './location_list.vue';

// i18n-lang-component
export default {
  name: 'historyReport',
  components: { locationList },
  data() {
    return {
      tagId: '',
      floorId: '',
      tags: [],
      tags1: [],
      selectDate: '',
      initValue: '',
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,
        orgId: undefined,
        orgName: '',
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',
        date: '',
        isToday: '',
        departmentId: '',
        departmentName: '',
      },
      totalRows: 2,
      stateTagList: [],
      dateTagList: [],
      locationNameTagList: [],
      tableList: [],

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      waitePaymentAmount: '-',
      isFilter: false,
    };
  },
  mounted: function () {
    this.initValue = `${this.$moment().format('YYYY-MM-DD')} 00:00:00`;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView();
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    // 是否是当天
    isToday(date) {
      return this.$moment(this.$momentElLocal(date)).isSame(this.$moment(), 'd') ? 1 : 0;
    },
    // 获取标签(项目)列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName,
          });
        }
      });
      this.tags = arr;
    },
    // 获取标签(区域)列表
    getTagsList1(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.floorId === item.floorId);
        if (!isHas && item.floorId && item.floorName) {
          arr.push({
            floorId: item.floorId,
            floorName: item.floorName,
          });
        }
      });
      this.tags1 = arr;
    },
    // 点击我的设备
    goDevice() {
      // 跳转到指定位置并且平滑滚动
      this.$el.querySelector('.decive_box_ref').scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    // 点击(项目)标签
    onItemTag(tagId) {
      if (tagId === this.tagId) {
        this.tagId = '';
      } else {
        this.tagId = tagId;
      }
    },
    // 点击(区域)标签
    onItemTag1(floorId) {
      if (floorId === this.floorId) {
        this.floorId = '';
      } else {
        this.floorId = floorId;
      }
    },
    // 过滤标签项目
    dataFilter: function (list) {
      if (!this.tagId) {
        return list;
      }
      return list.filter(t => t.tagId === this.tagId);
    },
    // 过滤标签区域
    dataFilter1: function (list) {
      if (!this.floorId) {
        return list;
      }
      return list.filter(t => t.floorId === this.floorId);
    },
    // 变更租赁方过滤
    onChangeCustomer() {
      if (!this.formSearch.orgId) {
        this.tags = [];
        this.tags1 = [];
        this.tagId = '';
        this.floorId = '';
      }
      this.onPageChange({ page: 1 });
    },
    // 清空过滤
    onClear() {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 获取表格数据
    getTableList() {
      this.formSearch.date = this.selectDate;
      this.formSearch.isToday = this.isToday(this.selectDate);
      // 提交需要去除这个字段 locationName
      this.$getJSON(
        apis.ProtalLocationPage,
        Object.assign({}, this.formSearch, {
          locationName: '',
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
          reportDate: this.$momentElLocal(this.formSearch.date, 'YYYY-MM-DD')
        })
      ).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.day-report-bd {
  .icon-filter {
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    font-size: 14px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    color: $--color-text-primary;
    box-shadow: 0 0 0 1.5px #202945 inset;
    border-radius: 50px;
    cursor: pointer;
  }
}
</style>
